import { useMemo } from 'react';
import { useLocation, useMatches } from 'react-router-dom';

import {
  getSessionTypeFromPathname,
  PageSessionType,
  RouteHandle,
} from '../utilities/page-session';

export function usePageSessionType(): PageSessionType {
  const matches = useMatches();
  const { pathname } = useLocation();

  return useMemo(() => {
    for (let i = matches.length - 1; i >= 0; i -= 1) {
      const handle = matches[i].handle as RouteHandle | undefined;
      if (handle?.sessionType) return handle.sessionType;
    }
    return getSessionTypeFromPathname(pathname);
  }, [matches, pathname]);
}
